import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import { Store } from "@ngrx/store";
import { UI__REQUEST_SET_LANG } from "../../ngrx/ngrx-actions";
import { CommonModule } from "@angular/common";

@Component({
  selector: "lang-switch",
  templateUrl: "./lang-switch.component.html",
  styleUrls: ["./lang-switch.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class LangSwitchComponent implements OnInit {
  langOptions: string[] = ["en", "he"];

  constructor(
    private readonly store: Store,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {}

  isSelected(lang: string): boolean {
    return SharedService.ui_lang == lang;
  }

  changeLang(lang: string) {
    this.store.dispatch(
      UI__REQUEST_SET_LANG({
        lang: lang,
      })
    );
  }
}
